<div class='container-float'>

  <b-row>
    <b-col cols="3">
      <b-form-input class="custom-input" v-model="filter.customer" placeholder="Cliente"></b-form-input>
    </b-col>
    <b-col cols="1">
      <b-form-input class="custom-input" v-model="filter.start_date" placeholder="Da data"></b-form-input>
    </b-col>
    <b-col cols="1">
      <b-form-input class="custom-input" v-model="filter.end_date" placeholder="A data"></b-form-input>
    </b-col>
    <b-col cols="1">
      <b-form-input class="custom-input" v-model="filter.currency" placeholder="Valuta"></b-form-input>
    </b-col>
    <b-col cols="2">
      <b-form-input class="custom-input" v-model="filter.location1" placeholder="Loc. 1"></b-form-input>
    </b-col>
    <b-col cols="2">
      <b-form-input class="custom-input" v-model="filter.location2" placeholder="Loc. 1"></b-form-input>
    </b-col>
    <b-col cols="1">
      <b-form-input class="custom-input" v-model="filter.base" placeholder="Base"></b-form-input>
    </b-col>
    <b-col cols="1">
      <b-form-input class="custom-input" v-model="filter.formula" placeholder="Formula"></b-form-input>
    </b-col>
  </b-row>
  
</div>